import { urls } from '../config/urls';

export const exhibitionPath = (exhibition) => `/exhibitions/${exhibition.slug || exhibition.id}`;

export const exhibitionPublicUrl = (exhibition) => `${urls.app.base}${exhibitionPath(exhibition)}`;
